import React from 'react';
import { Card, Typography, List, Tag, Divider } from 'antd';
import { User } from '@/types';

const { Title, Text } = Typography;

interface QuickAccessCardProps {
  title: string;
  icon: React.ReactNode;
  iconColor?: string;
  description: string;
  users: User[];
  onUserClick: (email: string) => void;
  showRegions?: boolean;
}

export const QuickAccessCard: React.FC<QuickAccessCardProps> = ({
  title,
  icon,
  iconColor,
  description,
  users,
  onUserClick,
  showRegions = false,
}) => {
  return (
    <Card>
      <Title level={4} className="flex items-center gap-2 mb-4">
        <span className={iconColor}>{icon}</span> {title}
      </Title>
      <Divider className="mt-0" />
      <Text type="secondary" className="block mb-4">{description}</Text>

      <List
        size="small"
        dataSource={users.slice(0, 5)}
        renderItem={(user) => (
          <List.Item
            className="cursor-pointer hover:bg-gray-50 px-4 -mx-4 rounded"
            onClick={() => onUserClick(user.email)}
          >
            <List.Item.Meta
              title={user.installerCompanyName || `${user.name} ${user.surname}`}
              description={
                <div>
                  <Text className="block text-xs">{user.email}</Text>
                  {showRegions && user.assignedRegions.length > 0 && (
                    <div className="mt-1 flex gap-1 flex-wrap">
                      {user.assignedRegions.map(region => (
                        <Tag key={region} className="text-xs">
                          {region}
                        </Tag>
                      ))}
                    </div>
                  )}
                </div>
              }
            />
          </List.Item>
        )}
      />
    </Card>
  );
};
